import { useEffect, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { Alert, Box, Button, CircularProgress } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useGlobalStore, usePersistantStore } from "@/stores/global";
import useRights from "@/shared/api/useRights";
import request from "@/shared/api/request";
import { usePersistentDataGrid } from "@/shared/hooks/usePersistentDataGrid";
import { fuelReportColumns, type FuelReportRow } from "./fuelReportColumns";

export default function FuelReport() {
  const region = usePersistantStore((state) => state.region);
  const setPageTitle = useGlobalStore((state) => state.setPageTitle);
  const rights = useRights();
  const allowed = "DISPOSITION" in rights;
  useEffect(() => setPageTitle("Tankungen"), [setPageTitle]);
  const query = useQuery<FuelReportRow[]>({
    queryKey: ["getFuelReport", region],
    queryFn: ({ signal }) => request({ url: `/data/fuel-report/${region}`, method: "GET", signal }),
    enabled: allowed,
    staleTime: 0,
  });
  const columns = useMemo(fuelReportColumns, []);
  const { gridProps } = usePersistentDataGrid("global-fuel-report", columns, {
    sortModel: [{ field: "Erstelldatum", sort: "desc" }, { field: "ID", sort: "desc" }],
  });

  return <Box sx={{ flex: 1, minHeight: 0, display: "flex", p: 1 }}>
    {!allowed ? <Alert severity="error">Für die Tankliste werden Dispo-Rechte benötigt.</Alert>
      : query.isError ? <Alert severity="error" action={<Button onClick={() => query.refetch()}>Erneut laden</Button>}>Die Tankliste konnte nicht vollständig geladen werden.</Alert>
      : !query.isSuccess || query.isFetching ? <Box sx={{ m: "auto", display: "flex", gap: 2, alignItems: "center" }}><CircularProgress size={24} />Tankungen werden vollständig geladen …</Box>
      : <DataGridPro<FuelReportRow> rows={query.data} getRowId={(row) => row.ID} rowHeight={36} showToolbar {...gridProps} />}
  </Box>;
}
